import { RouteLink, IRouteLinkProps } from 'route/components/RouteLink';

import { CardActionArea } from './CardActionArea';

export const CardActionLinkArea = (props: IRouteLinkProps) => (
    <CardActionArea component={RouteLink} {...props} />
);
